<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="Fornecedor/Credor"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}" page-change="{{pagTitulo}}"
            show-change="true" image-title="assets/img/global/fornecedor.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/favorecidos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-9">
          <label class=" mr-2" style="font-weight: bold; color: #009688 ">NÚMERO:</label>
          <label type="text" readonly id="numero_"
            style="font-size: 18px; font-weight: bold; color: #009688 ">{{ ("00000" + entidadeForm.get('id').value).slice(-5) }}</label>
        </div>
        <div class="col-3">

        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-md-12">
              <label for="nome">Nome/Razão social</label>
              <input value="{{entidadeForm.get('cpf_cnpj').value}} {{entidadeForm.get('nome').value}}" type="text"
                class="form-control-plaintext font-weight-bold" id="nome">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="endereco">Endereço</label>
              <input formControlName="endereco" type="text" class="form-control-plaintext" id="endereco">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="bairro">Bairro</label>
              <input value="{{entidade.bairro}}" readonly type="text" class="form-control-plaintext" id="bairro">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="bairro">Cidade</label>
              <input value="{{entidade.municipio}}" readonly type="text" class="form-control-plaintext">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-6">
            <lib-chart type="bar" [data]="dataBar"></lib-chart>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>
